import { json, useLoaderData } from 'react-router-dom';
import { doFetch } from '../../utils/doFetch';

export const errorTestRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  const errorType = params.errorType;
  if (errorType === "1") {
    return doFetch(`api-route-that-will-return-404`, { signal: request.signal }, true, false);
  } else if (errorType === "2") {
    throw json({ message: "Unauthorized" }, { status: 401 });
  } else if (errorType === "3") {
    throw json({ message: "Upgrade Required" }, { status: 426 });
  } else if (errorType === "4") {
    return doFetch(`welcome`, { signal: request.signal }, true, false);
  }
}

export const ErrorTestRoute = () => {
  const data = useLoaderData() as any;
  /// This simulates a render error because of null exception accessing .some.prop
  const somePropThatWontExist = data.some.prop
  return <div>{somePropThatWontExist}</div>;
}

/** README

Testing for https://devops.bcmea.com/tfs/BCMEA/Agile/_workitems?id=24314&triage=false&fullScreen=false&_a=edit
This route is meant to help test error pages until we get a better solution for creating errors

# Step 1. Processing Unhandled Errors - Unable to Contact Server
  * (Okay) Navigate to /error-test/1 (Calls WebApi route that doesn't exist; 404; Observe Error; Retry or nav away)
  * (Best) Block URI in Chrome; Navigate Welcome; Observe Error; Retry; Unblock URI; Retry
  * (Best) Ask Dev to turn off Server/Force Error; Navigate Welcome; Observe Error; Retry; Unblock URI; Retry

# Step 2. Processing Unhandled Errors - Unauthorized SMB Logged-In User
  * (Okay) Navigate to /error-test/2 while signed in (Simulates 401; Observe error; Go to home page)
  * (Best) Navigate to a route user cannot access while signed in(Eventually we can test this with telephone-board)

# Step 3. Processing Unhandled Errors - Unauthorized Anonymous User
  * (Okay) Navigate to /error-test/2 while not signed in (Simulates 401; Observe error)
  * (Best) Navigate to /my-profile while not signed in

# Step 4. Processing Unhandled Errors - Server Update
  * (Okay) Navigate to /error-test/3 (Simulates 426; Observe error; Refresh page)
  * (Best) Open App; Deploy new version for app; Navigate to another page using the nav menu; Observe Error; Refresh Page

# Step 5. Processing Unhandled Errors - Page Fails to Render
  * (Okay) Navigate to /error-test/4 (Simulates a render error by throwing an Error; Retry; Navigate away)

# Step 6. Processing Unhandled Errors - Page Does Not Exist
  * (Best) Navigate to /route-that-doesnt-exist; Go back to home

# Step 7. Processing Unhandled Errors - Unauthorized IVR Logged-In User
  * Cannot be tested until Authentication use case complete

 */